import React, { forwardRef } from "react";
import { container } from "@styles/common-styles.module.css";
import { section } from "./layout.module.css";
import { cn } from "@/utils";

interface SectionProps extends React.HTMLProps<HTMLDivElement> {
  fullscreen?: boolean;
}

const Section: React.ForwardRefExoticComponent<
  Omit<SectionProps, "ref"> & React.RefAttributes<HTMLDivElement>
> = forwardRef<HTMLDivElement, SectionProps>(({ className, children, ...props }, ref) => {
  return (
    <section ref={ref} className={`${section} ${container} ${cn("", className)}`} {...props}>
      {children}
    </section>
  );
});

export default Section;
